import { RootState } from '@/app/store'
import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { InternalMisconfigurationError } from '../external/ExternalPremiumLogin/ErrorComponents'
import { User } from '@/types/User'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ROUTE_LOGIN } from '@/constants/Routes'

const selectSelf = (state: RootState) => state

export const userStateSelector = createDraftSafeSelector(selectSelf, (state) => state.user)

/**
 * Misleading name, this selector returns the user state.
 * @deprecated Use `userStateSelector` if you need that state of the user object. Use `userRequiredSelector` if you need the user, and for it to be guaranteed to be present.
 * @see userStateSelector
 * @see useRequiredUser
 * */
export const userSelector = userStateSelector

export const useRequiredUser = (): User => {
  const navigate = useNavigate()

  return useSelector((state: RootState) => {
    if (!state.user.user) {
      navigate(ROUTE_LOGIN)
      throw new InternalMisconfigurationError('User is not defined')
    }
    return state.user.user
  })
}

export const useOptionalUser = (): User | null => {
  return useSelector((state: RootState) => state.user.user)
}

export const useUserRoot = () => {
  return useSelector((state: RootState) => state.user)
}
